import { render } from "./BusinessStatusV1.vue?vue&type=template&id=6133c0c8"
import script from "./BusinessStatusV1.vue?vue&type=script&lang=js"
export * from "./BusinessStatusV1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__